// TODO (markn): make these names easier to import
import * as geCampaignType from '../../../../../typeModules/guaranteedEarningsCampaign'
import * as geRedirectModalType from '../../../../../typeModules/guaranteedEarningsRedirectModal'
import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'
import {
  trackGEExpiredModalDismiss,
  trackGEExpiredModalRender,
  trackGEInvalidZipContinue,
  trackGEInvalidZipDismiss,
  trackGEInvalidZipModalRender,
  trackGEInvalidZipTermsClick,
} from '../../../../../events'
import { push, Steps } from '../../../../../utilities/steps'
import { connect } from 'react-redux'
import Button from '@doordash/component-button'
import { Modal } from '@doordash/component-modal'
import { TermsButton } from './styles'

/* tslint:disable:no-console */
const missingTrackingEventLogger = (geRedirectModal, event) =>
  console.log(`No tracking event for ${geRedirectModal.type} type on ${event}`)
/* tslint:enable:no-console */

type ModalProps = {
  dismissGuaranteedEarningsRedirectModal: any
  guaranteedEarningsRedirectModal: any
  dasherApplySubmittingApplication: boolean
  submitDasherApplication: any
  trackGEExpiredModalDismiss?: any
  trackGEExpiredModalRender?: any
  trackGEInvalidZipContinue?: any
  trackGEInvalidZipDismiss?: any
  trackGEInvalidZipModalRender?: any
  trackGEInvalidZipTermsClick?: any
}
export class GuaranteedEarningsRedirectModal extends React.Component<
  ModalProps & RouteComponentProps<any>
> {
  public state = {
    termsOpen: false,
  }

  public getModalMountTrackingEvents = () => ({
    [geRedirectModalType.GEType.EXPIRED]: this.props.trackGEExpiredModalRender,
    [geRedirectModalType.GEType.ELIGIBLE_FOR_ALTERNATIVE_CAMPAIGN]: this.props
      .trackGEInvalidZipModalRender,
    [geRedirectModalType.GEType.NO_OFFER_AVAILABLE]: this.props
      .trackGEInvalidZipModalRender,
  })

  public getModalDismissTrackingEvents = () => ({
    [geRedirectModalType.GEType.EXPIRED]: this.props.trackGEExpiredModalDismiss,
    [geRedirectModalType.GEType.ELIGIBLE_FOR_ALTERNATIVE_CAMPAIGN]: this.props
      .trackGEInvalidZipDismiss,
    [geRedirectModalType.GEType.NO_OFFER_AVAILABLE]: this.props
      .trackGEInvalidZipDismiss,
  })

  public getModalContinueTrackingEvents = () => ({
    [geRedirectModalType.GEType.EXPIRED]: this.props.trackGEExpiredModalDismiss,
    [geRedirectModalType.GEType.ELIGIBLE_FOR_ALTERNATIVE_CAMPAIGN]: this.props
      .trackGEInvalidZipContinue,
    [geRedirectModalType.GEType.NO_OFFER_AVAILABLE]: this.props
      .trackGEInvalidZipContinue,
  })

  public componentDidMount() {
    const { guaranteedEarningsRedirectModal } = this.props
    const trackingEvent =
      this.getModalMountTrackingEvents()[
        guaranteedEarningsRedirectModal.type
      ] ||
      (() =>
        missingTrackingEventLogger(guaranteedEarningsRedirectModal, 'mount'))
    trackingEvent(guaranteedEarningsRedirectModal)
  }

  public toggleTerms = () => {
    const { guaranteedEarningsRedirectModal } = this.props
    trackGEInvalidZipTermsClick(guaranteedEarningsRedirectModal)
    this.setState({ termsOpen: !this.state.termsOpen })
  }

  public submitApplication = async () => {
    const {
      guaranteedEarningsRedirectModal,
      submitDasherApplication,
      history,
    } = this.props

    const guaranteedEarningsCode = guaranteedEarningsRedirectModal.campaign
      ? guaranteedEarningsRedirectModal.campaign.unique_hash
      : undefined

    try {
      const result = await submitDasherApplication({
        ...guaranteedEarningsRedirectModal.applicationData,
        guaranteedEarningsCode,
      })
      push(result.uniqueLink, Steps.ProfileSetup, history)
    } catch (errors) {
      throw errors
    }
  }

  public isExpiredModal = () => {
    const { guaranteedEarningsRedirectModal } = this.props
    return geRedirectModalType.isExpiredModal(guaranteedEarningsRedirectModal)
  }

  public continue = () => {
    const {
      dismissGuaranteedEarningsRedirectModal,
      guaranteedEarningsRedirectModal,
    } = this.props

    const trackingEvent =
      this.getModalContinueTrackingEvents()[
        guaranteedEarningsRedirectModal.type
      ] ||
      (() =>
        missingTrackingEventLogger(guaranteedEarningsRedirectModal, 'continue'))

    trackingEvent(guaranteedEarningsRedirectModal)

    if (this.isExpiredModal()) {
      return dismissGuaranteedEarningsRedirectModal()
    }
    return this.submitApplication()
  }

  public dismiss = () => {
    const {
      dismissGuaranteedEarningsRedirectModal,
      guaranteedEarningsRedirectModal,
    } = this.props

    const trackingEvent =
      this.getModalDismissTrackingEvents()[
        guaranteedEarningsRedirectModal.type
      ] ||
      (() =>
        missingTrackingEventLogger(guaranteedEarningsRedirectModal, 'dismiss'))
    trackingEvent(guaranteedEarningsRedirectModal)

    dismissGuaranteedEarningsRedirectModal()
  }

  public render() {
    const {
      guaranteedEarningsRedirectModal,
      dasherApplySubmittingApplication,
    } = this.props
    const { termsOpen } = this.state

    const isExpiredModal = geRedirectModalType.isExpiredModal(
      guaranteedEarningsRedirectModal
    )

    return (
      <Modal
        title={geRedirectModalType.getTitle(guaranteedEarningsRedirectModal)}
        onClose={this.dismiss}
        primaryAction={{
          text: 'Continue',
          onClick: this.continue,
          buttonProps: {
            state: dasherApplySubmittingApplication
              ? Button.States.Loading
              : Button.States.Default,
          },
        }}
        secondaryAction={
          isExpiredModal
            ? null
            : {
                text: 'Cancel',
                onClick: this.dismiss,
              }
        }
        actionsFillContainer
        hasCloseButton={false}
        headerAlignment={Modal.HeaderAlignment.Left}
      >
        <StackChildren size={StackChildren.Sizes.Large}>
          <Text>
            {geRedirectModalType.getContent(guaranteedEarningsRedirectModal)}
          </Text>
          {guaranteedEarningsRedirectModal.campaign &&
            (termsOpen ? (
              <StackChildren>
                <Text styles={Text.Styles.SectionTitle}>Terms</Text>
                <Text
                  styles={Text.Styles.LegalText}
                  lineHeight={Text.LineHeights.Medium}
                >
                  {geCampaignType.getTermsCopy(
                    guaranteedEarningsRedirectModal.campaign
                  )}
                </Text>
              </StackChildren>
            ) : (
              <TermsButton
                styles={Text.Styles.ContentAction}
                onClick={this.toggleTerms}
              >
                See Terms
              </TermsButton>
            ))}
        </StackChildren>
      </Modal>
    )
  }
}

const mapDispatchToProps = {
  trackGEExpiredModalDismiss,
  trackGEExpiredModalRender,
  trackGEInvalidZipContinue,
  trackGEInvalidZipDismiss,
  trackGEInvalidZipModalRender,
  trackGEInvalidZipTermsClick,
}

export default withRouter<ModalProps & RouteComponentProps<any>>(
  connect(null, mapDispatchToProps)(GuaranteedEarningsRedirectModal)
)
